<<template>  
  <prop-panel @close="close">
    <p slot="header">请假时间</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" >
          <span class="input-group-addon" >{{rs["xdate1"]}}</span>
            <date-input :formater='"yyyy-MM-dd"' class="form-control" v-model="beginDate"/>
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate2"]}}</span>
            <date-input :formater='"yyyy-MM-dd"' class="form-control" v-model="endDate"/>
        </div>
    </div>

    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" >
          <span class="input-group-addon" >{{rs["beginTime"]}}</span>
          <date-input :formater='"HH:mm"' v-model="beginTime" class="form-control"/>
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["endTime"]}}</span>
          <date-input :formater='"HH:mm"' v-model="endTime" class="form-control"/>
        </div>
    </div>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" >
          <span class="input-group-addon" >{{rs["leaveTime"]}}</span>
          <date-input :formater='"HH:mm"' v-model="leaveTime" class="form-control"/>
        </div>
      <div class="input-group col-md-5"  style="margin-left:0" >
        <span class="input-group-addon" >{{rs["dayOrNight"]}}</span>
        <select  class="form-control" v-model="dayOrNight">
          <option value='1'>{{rs["dayOrNight1"]}}</option>
          <option value='2'>{{rs["dayOrNight2"]}}</option>
        </select>
      </div>
    </div>

    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="create" type="button" class="btn btn-primary">确定</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created(){
    if (this.itime.beginDate) this.beginDate = this.formatter.fdate(this.itime.beginDate)
    if (this.itime.endDate) this.endDate = this.formatter.fdate(this.itime.endDate)
    if (this.itime.beginTime) this.beginTime = this.formatter.ftime(this.itime.beginTime)
    if (this.itime.endTime) this.endTime = this.formatter.ftime(this.itime.endTime)
    if (this.itime.leaveTime) this.leaveTime = this.formatter.ftime(this.itime.leaveTime)
    this.dayOrNight = this.itime.dayOrNight?this.itime.dayOrNight:1
  },
  props:["rs", "itime", "idx", "times"],
  data(){
    return {
      beginDate: "",
      endDate: "",
      beginTime: "",
      endTime: "",
      leaveTime:"00:00",
      dayOrNight:1
    }
  },
  methods:{
    close: function() {
      this.$emit("close")
    },
    create(){
       if (!this.checkNull(this.beginDate, "bdNull")) return false 
       if (!this.checkNull(this.endDate, "edNull")) return false 
       if (!this.checkNull(this.beginTime, "btNull")) return false 
       if (!this.checkNull(this.endTime, "etNull")) return false 
      //console.log(this.beginDate)
      const dtime ={dayOrNight: this.dayOrNight}
     // console.log(1)
      dtime.beginDate = this.beginDate + " 00:00:00"
      //console.log(2)
      dtime.endDate = this.endDate + " 00:00:00"
      dtime.beginTime = "1900-01-01 " + this.beginTime
      dtime.endTime = "1900-01-01 " + this.endTime
      if (!this.leaveTime || this.leaveTime=="") dtime.leaveTime="1900-01-01"
      else dtime.leaveTime="1900-01-01 " + this.leaveTime
      //console.log(3)
      if (this.idx==-1) this.times.push(dtime)
      else this.$set(this.times, this.idx, dtime)
      //console.log(5)
      this.$emit("close")
      //console.log(6)
    }
  }
}
</script>